import React, { ChangeEventHandler, forwardRef, useCallback } from 'react';

import { ReservationFlowCustomerFieldItem } from 'src/interfaces/reservation_flow';
import { CustomerSelect } from 'src/templates/merchants/resources/book/components/forms/CustomerSelect';
import { useDataAttributeProps } from 'src/hooks/useDataAttributeProps';

export interface CustomerInfoInputSelectProps {
  [key: `data-${string}`]: string | undefined;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  item: ReservationFlowCustomerFieldItem;
  isError?: boolean;
}

export const CustomerInfoInputSelect = forwardRef<
  HTMLSelectElement,
  CustomerInfoInputSelectProps
>((props, ref) => {
  const dataAttributes = useDataAttributeProps(props);
  const { value, onChange, onBlur, item, isError } = props;
  const onInputChange = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    (event) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div>
      <CustomerSelect
        {...dataAttributes}
        ref={ref}
        labelText={item.label}
        isBlock
        isError={isError}
        required={item.is_required}
        value={typeof value !== 'undefined' ? value : ''}
        onChange={onInputChange}
        onBlur={onBlur}
      >
        <option
          value=""
          style={{ display: item.is_required ? 'none' : undefined }}
        />
        {item.options &&
          item.options.map((option) => {
            return (
              <option
                key={`customerInfo_${item.key}_${option.key}`}
                value={option.key}
              >
                {option.value}
              </option>
            );
          })}
      </CustomerSelect>
    </div>
  );
});

CustomerInfoInputSelect.displayName = 'CustomerInfoInputSelect';
